import React, { useContext, useEffect, useState } from 'react';
import { CompanyContext } from '../../../../../context/CompanyContext';
import {
  CompanyRelationService,
  IntegrationSettings,
  IntegrationSettingsInput,
} from '../../../../../types/integration_settings';
import { TranslationKey } from '../../../../../types/translation/TranslationKey';
import { translate } from '../../../../../types/translation/Translator';
import { ActionModal } from '../../../../components/Modal';
import IntegrationModalTypePane from './Panes/IntegrationModalTypePane';
import TeamleaderIntegrationPane from './Panes/Teamleader/TeamleaderIntegrationPane';
import MicrosoftIntegrationPane from './Panes/Microsoft/MicrosoftIntegrationPane';
import { IntegrationContext } from '../../../../../context/IntegrationContext';
import BusinessCentralIntegrationPane from './Panes/BusinessCentral/BusinessCentralIntegrationPane';

export enum IntegrationModalState {
  type = 'type',
  info = 'info',
  company = 'company',

  teamleader = 'teamleader',
  microsoft = 'microsoft',
  businessCentral = 'businessCentral',
}

interface IntegrationModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  integration: IntegrationSettings | undefined;
}

export default function IntegrationModal({ open, setOpen, integration }: IntegrationModalProps) {
  const { integrationSettings } = useContext(IntegrationContext);

  const companyId = useContext(CompanyContext).currentCompany.id;

  const determineType = () => {
    if (input.id && input.type === CompanyRelationService.teamleader) {
      return IntegrationModalState.teamleader;
    } else if (input.id && input.type === CompanyRelationService.businessCentral) {
      return IntegrationModalState.businessCentral;
    } else if (input.id && input.type === CompanyRelationService.microsoft) {
      return IntegrationModalState.microsoft;
    }

    return IntegrationModalState.type;
  };

  const [input, setInput] = useState(new IntegrationSettingsInput(integration || { companyId }));
  const [state, setState] = useState(determineType());

  const handleCancel = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (!input.id || input.version) return;

    const existingIntegration = integrationSettings.get(input.id);
    if (existingIntegration) setInput(new IntegrationSettingsInput(existingIntegration));
  }, [integrationSettings]);

  const pane = () => {
    switch (state) {
      case IntegrationModalState.type:
        return (
          <IntegrationModalTypePane input={input} setInput={setInput} setType={setState} handleCancel={handleCancel} />
        );
      case IntegrationModalState.teamleader:
        return <TeamleaderIntegrationPane input={input} setInput={setInput} handleCancel={handleCancel} />;
      case IntegrationModalState.businessCentral:
        return (
          <BusinessCentralIntegrationPane
            input={input}
            setInput={setInput}
            handleCancel={handleCancel}
            loading={false}
          />
        );
      case IntegrationModalState.microsoft:
        return <MicrosoftIntegrationPane input={input} handleCancel={handleCancel} />;
    }
  };

  return (
    <ActionModal
      className='min-h-[400px]'
      title={translate({
        key: integration ? TranslationKey.integrationModalUpdateTitle : TranslationKey.integrationModalCreateTitle,
      })}
      open={open}
      setOpen={setOpen}
    >
      {pane()}
    </ActionModal>
  );
}
